const { SITE_BASE_URL, buildAbsoluteSiteUrl } = require('./brokerConnectionSource');

const BOTSPOT_EDITORIAL_AUTHOR = Object.freeze({
  '@type': 'Organization',
  name: 'BotSpot',
  url: '/about#editorial-policy',
});

const ROB_GRZESIK_AUTHOR = Object.freeze({
  '@type': 'Person',
  name: 'Robert Grzesik',
  url: '/about#rob-grzesik',
  sameAs: 'https://www.linkedin.com/in/robertgrzesik/',
});

function articleAuthorFor(author = BOTSPOT_EDITORIAL_AUTHOR, baseUrl = SITE_BASE_URL) {
  const result = { ...author };
  if (author.url) result.url = buildAbsoluteSiteUrl(author.url, baseUrl);
  return result;
}

function blogAuthorFor(authorName, baseUrl = SITE_BASE_URL) {
  const name = authorName?.trim() || 'The BotSpot Team';
  if (name === ROB_GRZESIK_AUTHOR.name) return articleAuthorFor(ROB_GRZESIK_AUTHOR, baseUrl);
  if (['BotSpot', 'The BotSpot Team', 'BotSpot Team'].includes(name)) {
    return articleAuthorFor({ ...BOTSPOT_EDITORIAL_AUTHOR, name }, baseUrl);
  }
  return { '@type': name === 'Lumiwealth' ? 'Organization' : 'Person', name };
}

module.exports = { BOTSPOT_EDITORIAL_AUTHOR, ROB_GRZESIK_AUTHOR, articleAuthorFor, blogAuthorFor };
